export default "__VITE_ASSET__99557ec2__"